import { render, staticRenderFns } from "./selectProductModules.vue?vue&type=template&id=25895c0c&scoped=true&"
import script from "./selectProductModules.vue?vue&type=script&lang=js&"
export * from "./selectProductModules.vue?vue&type=script&lang=js&"
import style0 from "./selectProductModules.vue?vue&type=style&index=0&id=25895c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25895c0c",
  null
  
)

export default component.exports